import React, { useState } from "react";
import Enumerable from "linq";

//material mui
import { Button } from "@mui/material";

//icons
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SendIcon from "@mui/icons-material/Send";

//config
import { enlistaArrayCodigosMensajesIdiomas } from "../../../Actions/Generales/IdiomasAction";
import { LlavesPortales } from "../../../Configuracion/Llaves/RepositorioConfig";
import { MostrarMensaje } from "../../../Utilidades/ManejoMensajes";
import { ValidarPropiedad } from "../../../Utilidades/ValidarPropiedades";
import CarpetasAdjuntos from "../../../Configuracion/Llaves/CarpetasAdjuntos";

//state global
import { stateAdmison } from "../Context/store";

//components
import {
  DialogoMostrarMensaje,
  mostrarDialogoMostrarMensaje,
} from "../../ControlUsuario/DialogoMostrarMensaje";

//hooks
import { useGlobalState } from "../../../Utilidades/useGlobalState";

import { MOBILE } from '../config';

//actions
import {
  requisitoAdmisionAceptado,
  ListadoRequisitosAdmisiones,
} from "../../../Actions/Admisiones/AdmisionesRequisitosAction";
import { crearAdmision } from "../../../Actions/Admisiones/AdmisionesAction";
import { InsertarAdjuntoRequisitos } from "../../../Actions/Admisiones/AdmisionesReqAdjuntosAction";
import { SubirArchivosServidor } from "../../../Actions/Utilidades/ManejoArchivosAction";

//styles
import { StyleHomeFooter, StyleHome } from "../../Tool/Style";

const HomeFooter = ({
  deviceIs = "DESKTOP",
  Credenciales = {},
  SetRequisitosPendientes = () => {},
  guardarCamposDinamicosProp = () => false,
  EstadoRegistro,
  SetEstadoRegistro,
  CodigoVerificado,
  CustomerId,
  RequisitosPendientes,
  SetAdmisionEstudiante,
  SetAdmisionPreExistente,
}) => {
  const { etiquetas, dispatch } = useGlobalState();

  const {
    list,
    admissionId,
    campusId,
    clasificationId,
    estadosAdmisionId,
    periodId,
    programId,
  } = stateAdmison();

  const [MensajeEnviar, setMensajeEnviar] = useState({
    TextoMostrar: "",
    FuncionAceptar: undefined,
  });

  const FuncionRedireccionar = () => {
    window.location.href = LlavesPortales.UrlPortalEstudiantes;
  };

  const funcionValidarEnviar = () => {
    if (RequisitosPendientes > 0)
      setMensajeEnviar({
        TextoMostrar: etiquetas.Home.Et_lblAdjuntosPendientes,
        FuncionAceptar: undefined,
      });
    else
      setMensajeEnviar({
        TextoMostrar: etiquetas.Home.Et_lblEnviarAdmisionMsg,
        FuncionAceptar: FuncionRedireccionar,
      });

    mostrarDialogoMostrarMensaje();
  };

  const sendAdmission = async () => {
    dispatch({
      type: "LOAD_HOME",
      texto: etiquetas.CargandoModal.Et_Procesando,
    });

    if (admissionId === "00000000-0000-0000-0000-000000000000") {
      const admisionResult = await salvarAdmision();

      if (!(admisionResult === "00000000-0000-0000-0000-000000000000")) {
        const objReq = { AdmissionId: admisionResult };

        const response = await ListadoRequisitosAdmisiones(objReq);

        if (response.status === 200) {
          const attachments = response.data.filter(
            (x) => x.aprFileRequired === true || x.aprAcceptRequirement === true
          );

          if (attachments.length > 0) {
            let auxArray = [];

            attachments.forEach((item) => {
              const found = list.find(
                (x) => x.aprProgramReqId === item.adrProgRequirementIdFk
              );

              if (found) {
                auxArray.push({
                  requirementId: item.adrRequirementId,
                  aprAcceptedByStudent: found.aprAcceptedByStudent,
                  aprAcceptRequirement: found.aprAcceptRequirement,
                  aprFileRequired: found.aprFileRequired,
                  fileDetail: found.fileDetail,
                });
              }
            }); //fin forEach attachments

            //auxArray.forEach(async (item) => {
            for (const item of auxArray) {
              if (item.aprAcceptedByStudent) {
                await requirementAdmissionAccepted(
                  item.requirementId,
                  item.aprAcceptedByStudent
                );
              }

              if (item.aprFileRequired && item.fileDetail !== null) {
                await guardarDataArchivo(item.fileDetail, item.requirementId);
              }
            } //)//fin forEach auxArray

            const responseVerificaAdj = await ListadoRequisitosAdmisiones(
              objReq
            );

            const sinAdjuntos = Enumerable.from(responseVerificaAdj.data)
              .where(
                (x) =>
                  x.attachments === false &&
                  x.aprFileRequired === true &&
                  x.isRequired === true
              )
              .toArray();

            if (sinAdjuntos.length > 0) {
              SetAdmisionEstudiante(admisionResult);
              SetAdmisionPreExistente(true);
              setMensajeEnviar({
                TextoMostrar: etiquetas.Home.Et_lblAdjuntosPendientes,
                FuncionAceptar: undefined,
              });
            } else {
              setMensajeEnviar({
                TextoMostrar: etiquetas.Home.Et_lblEnviarAdmisionMsg,
                FuncionAceptar: FuncionRedireccionar,
              });
            }
            mostrarDialogoMostrarMensaje();
          } else {
            setMensajeEnviar({
              TextoMostrar: etiquetas.Home.Et_lblEnviarAdmisionMsg,
              FuncionAceptar: FuncionRedireccionar,
            });
            mostrarDialogoMostrarMensaje();

            SetRequisitosPendientes(0);
          }
        }
      }
    } else {
      funcionValidarEnviar();
    }
    dispatch({ type: "CLOSE_LOAD_HOME" });
  };


  const requirementAdmissionAccepted = async (aprRequirementIdFk, checked) => {
    const objReq = {
      requirementId: aprRequirementIdFk,
      accept: checked,
      companyId: Credenciales.companyId,
      userId: Credenciales.userId,
    };

    const response = await requisitoAdmisionAceptado(objReq);

    if (response.status === 200) {
      //MostrarMensaje(dispatch, 'success', ['updateOk']);
    } else {
      if (response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        MostrarMensaje(dispatch, "error", [response.statusText]);
      }
    }
  };

  const salvarAdmision = async () => {
    const objetoAdmision = {
      AdmissionId: "00000000-0000-0000-0000-000000000000",
      CustomerId: Credenciales.customerId,
      ProgramId: programId,
      CampusId: campusId,
      PeriodId: periodId,
      StatusId: estadosAdmisionId,
      ClassificationId: clasificationId,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };
    const FieldsRequired = [
      { code: "CustomerId", codeError: "WarningSelectEstudiante" },
      { code: "ProgramId", codeError: "WarningSelectPrograma" },
      { code: "PeriodId", codeError: "WarningSelectTipoPeriodo" },
      { code: "CampusId", codeError: "WarningSelectSede" },
      { code: "StatusId", codeError: "SearchFilterEstadoId" },
      { code: "ClassificationId", codeError: "SearchFilterClasf" },
    ];

    const validacionCampos = ValidarPropiedad(
      FieldsRequired,
      objetoAdmision,
      dispatch
    );

    if (validacionCampos) {
      return await crearAdmision(objetoAdmision).then((response) => {
        if (response.status === 200) {
          //si la respuesta fue existosa
          // admisionDispatch({type:'changeAdmissionId', payload:{ admissionId:response.data }});

          //MostrarMensaje(dispatch, 'success', ["ok"]);

          return response.data;
        } else {
          if (response.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
              response.data.errors
            );
            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
          } else {
            MostrarMensaje(dispatch, "error", [response.statusText]);
          }

          return "00000000-0000-0000-0000-000000000000";
        }
      });
    }
  };

  const SubirArchivoServidor = async (file, requirementId) => {
    let resultado = false;
    const dataObject = {
      FileType: file.tipo,
      FileContent: file.contenido,
      FileSize: file.tamano,
      FileName: file.nombre,
      ObjectId: requirementId,
      FolderName: CarpetasAdjuntos.RequisitosAdmision,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    await SubirArchivosServidor(dataObject).then((response) => {
      if (response.status === 201) {
        //si la respuesta fue existosa
        resultado = true;
      } else {
        if (response.status === 401) {
          MostrarMensaje(dispatch, "error", ["ErrorFile401"]);
        } else if (response.status === 409) {
          MostrarMensaje(dispatch, "warning", ["ErrorFile409"]);
        } else if (response.status === 500) {
          MostrarMensaje(dispatch, "error", ["InternalServerError"]);
        } else if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      }
    });

    return resultado;
  };

  const guardarDataArchivo = async (fileInfo, requirementId) => {
    let ProcesarSiguiente = true;

    if (ProcesarSiguiente) {
      ProcesarSiguiente = await SubirArchivoServidor(fileInfo, requirementId);
    }
    if (ProcesarSiguiente) {
      ProcesarSiguiente = await InsertarArchivo(fileInfo, requirementId);
    }
  };

  const InsertarArchivo = async (file, requirementId) => {
    let resultado = false;
    const objetoAdjunto = {
      RequirementId: requirementId,
      FileName: file.nombre,
      MimeType: file.tipo,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    const responseInsertarAdjunto = await InsertarAdjuntoRequisitos(
      objetoAdjunto
    );
    if (responseInsertarAdjunto.status === 200) {
      //si la respuesta fue existosa
      //MostrarMensaje(dispatch, 'success', ["updateOk"]);
      resultado = true;
    } else {
      if (responseInsertarAdjunto.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          responseInsertarAdjunto.data.errors
        );
        MostrarMensaje(
          dispatch,
          responseInsertarAdjunto.data.typeError,
          arrayErrores
        );
      } else {
        MostrarMensaje(dispatch, "error", [responseInsertarAdjunto.statusText]);
      }
    }

    return resultado;
  };

  return (
    <div style={ deviceIs === MOBILE ? { display:'flex', gap:"5px", padding: "9px", marginBottom:'8px', marginTop:"0px", } : StyleHomeFooter.Container}>
      <Button
        disabled={CodigoVerificado === false || EstadoRegistro === true}
        startIcon={<ArrowBackIosNewIcon style={{ color: "#3F425D" }} />}
        style={
          EstadoRegistro === true
            ? { ...StyleHome.ButtonClean, ...{ width: deviceIs === MOBILE ? '47.5%' : 150, marginLeft: 10 } }
            : deviceIs === MOBILE ? { 
              width: deviceIs === MOBILE ? '47.5%': 150,
              color: '#3F425D',
              backgroundColor: '#1EE3CF', } : StyleHomeFooter.Button
        }
        onClick={() => {
          SetEstadoRegistro(true);
        }}
      >
        {etiquetas.General.Et_tbnAtras}
      </Button>
      <div
        style={{
          width: deviceIs === MOBILE ? '47.5%': 'initial',
          textAlign:'center',
          display:
            CodigoVerificado === false || EstadoRegistro === true
              ? "initial"
              : "none",
          margin: "0px",
          padding: "0px",
        }}
      >
        <Button
          disabled={
            CustomerId === "00000000-0000-0000-0000-000000000000" ||
            CodigoVerificado === false ||
            EstadoRegistro === false
          }
          endIcon={<ArrowForwardIosIcon style={{ color: "#3F425D" }} />}
          style={
            CustomerId !== "00000000-0000-0000-0000-000000000000" &&
            CodigoVerificado === true &&
            EstadoRegistro === true
              ? deviceIs === MOBILE ? { 
                width: deviceIs === MOBILE ? '100%': 150,
                color: '#3F425D',
                backgroundColor: '#1EE3CF', } : StyleHomeFooter.Button
              : { ...StyleHome.ButtonClean, ...{ width: deviceIs === MOBILE ? '100%' : 150, marginLeft: deviceIs === MOBILE ? 0 : 10 } }
          }
          onClick={async () => {
            const result = await guardarCamposDinamicosProp();

            if (result) {
              SetEstadoRegistro(false);
            }
          }}
        >
          {etiquetas.General.Et_tbnSiguiente}
        </Button>
      </div>
      
      { deviceIs === MOBILE ? null : <div
        style={{
          display:
            CodigoVerificado === false || EstadoRegistro === true
              ? "none"
              : "initial",
          margin: "0px",
          padding: "0px",
        }}
      >
        <Button
          startIcon={<SendIcon style={{ color: "#3F425D" }} />}
          style={StyleHomeFooter.Button}
          onClick={() => {
            sendAdmission(); /*funcionValidarEnviar()*/
          }}
        >
          {etiquetas.ToolbarButtons.Et_BtnEnviar}
        </Button>
      </div> }

      <DialogoMostrarMensaje
        deviceIs={deviceIs}
        TextoMostrar={MensajeEnviar.TextoMostrar}
        funcionAceptar={MensajeEnviar.FuncionAceptar}
      />
    </div>
  );
};

export default HomeFooter;
